import React from 'react';
import { getCaseNumberLabel } from '../../../Utils/ReportUtils';

const ReportHeader = ({ 
  firstPeriodData, 
  secondPeriodData, 
  showPeriodComparison, 
  uniquePalCodeCategories, 
  uniquePalCodes,
  formatDateRange,
  byProjectsFilterActive,
  selectedFromSegmentation,
  selectedToSegmentation,
  t,
  escapeHtmlAttr,
  caseType,
}) => {
  const now = new Date();
  const currentTime = now.toLocaleTimeString("he-IL", { 
    hour: "2-digit", 
    minute: "2-digit",
    hour12: false 
  });
  const day = now.getDate().toString().padStart(2, '0');
  const month = (now.getMonth() + 1).toString().padStart(2, '0');
  const year = now.getFullYear().toString();
  const currentDate = `${day}/${month}/${year}`;

  return `
    <div class="report-page-header pageStyle">
      <div class="report-header-row">
        <div class="report-header-title-block">
          <h1 class="report-title">דו"ח רווח והפסד</h1>
          ${!showPeriodComparison ? `
            <p class="report-date-range">טווח תאריכים: ${firstPeriodData.startDate} - ${firstPeriodData.endDate}</p>
          ` : `
            <div class="report-date-comparison-block">
              <span class="report-date-range report-comparison-period">
                ${formatDateRange(firstPeriodData.startDate, firstPeriodData.endDate, 'מתקופה')}
              </span>
              ${secondPeriodData ? `
                <span class="report-date-range report-comparison-period">
                  ${formatDateRange(secondPeriodData.startDate, secondPeriodData.endDate, 'לתקופה')}
                </span>
              ` : ''}
            </div>
          `}
        </div>
        <div class="report-header-client-block">
          <p class="report-client-name">${firstPeriodData.clientName}</p>
          <p class="report-client-case">${getCaseNumberLabel(caseType ?? firstPeriodData?.caseType)}: ${firstPeriodData.clientCase}</p>
          <p class="report-print-datetime">תאריך הדפסה: ${currentTime} - ${currentDate}</p>
        </div>
      </div>
      <hr class="report-header-divider" />

      <div class="report-meta-details sum-details">
        <div class="palcodes-details">
          מסעיף: ${uniquePalCodeCategories[0] || ''} 
          - עד סעיף: ${uniquePalCodeCategories[uniquePalCodeCategories.length - 1] || ''}
        </div>
        <div class="palcodes-details">
          מסיווג: ${uniquePalCodes[0] || ''} 
          - עד סיווג: ${uniquePalCodes[uniquePalCodes.length - 1] || ''}
        </div>
        ${byProjectsFilterActive && t && escapeHtmlAttr ? (() => {
          let projectLine = '';
          if (!selectedFromSegmentation && !selectedToSegmentation) {
            projectLine = escapeHtmlAttr(t('TrialBalanceProjectFilterAllSegmented'));
          } else {
            const fromL = selectedFromSegmentation ? escapeHtmlAttr(selectedFromSegmentation.label) : '—';
            const toL = selectedToSegmentation ? escapeHtmlAttr(selectedToSegmentation.label) : '—';
            projectLine = `<span class="report-project-range"><span>${escapeHtmlAttr(t('FromProject'))}: <span dir="ltr">${fromL}</span></span><span>${escapeHtmlAttr(t('ToProject'))}: <span dir="ltr">${toL}</span></span></span>`;
          }
          return `<div class="palcodes-details report-project-filter" dir="rtl"><span>${escapeHtmlAttr(t('ByProjects'))}:</span> ${projectLine}</div>`;
        })() : ''}
      </div>
    </div>
  `;
};

export default ReportHeader;
